import { type ReactNode } from 'react'
import { type EmailType } from '#app/components/email/template.tsx'

export function HeadingText({
  type,
  children,
}: {
  type: EmailType
  children: ReactNode
}) {
  const color =
    type === 'sign-up' ? 'hsla(192, 85%, 31%, 1)' : 'hsla(24, 40%, 22%, 1)'
  const colorStyle = { color }

  return (
    <h1
      style={colorStyle}
      className="text-5 mt-[48px] text-center font-bold tracking-[-0.12px]"
    >
      {children}
    </h1>
  )
}
